import { RelatorioServicosVeicularesModel } from '@/models/administracao/servicos-veiculares/RelatorioServicosVeicularesModel';
import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';

export default class DataCemproService {

    static gerarRelatorio(tipo: string, request: any) {
        return integracaoContabilApi.gerarRelatorioDataCempro(tipo, request);
    }
}